import styled from 'styled-components'

export const Container = styled.div`
 @media(max-width:768px){
      width:100%;
    }`

export const Input = styled.input`
  width: 80%;
  min-height: 100%;
  outline: none;
  border: none;
  background: #e8f0f7;
  border-radius: 10px;
  padding: 7px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 15px;

  &:focus::placeholder {
    color: transparent;
  }

  color: #526482;
   @media(max-width:768px){
      width:100%;
    }
`
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 255px;
  min-height: 100%;
  outline: none;
  border: none;
  background: #e8f0f7;
  border-radius: 10px;
  padding: 12px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 15px;

  &:focus::placeholder {
    color: transparent;
  }

  color: #526482;
   @media(max-width:768px){
      width:100%;
    }
`
